import React, { useEffect, useState } from 'react';
import { ToastContainer } from "react-toastify";
import BlogCard from '@/modules/frontend/components/Blog/BlogCard';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { fetchBlogPosts, fetchCategories, selectFormattedCategories2 } from '@/store/modern/slices/newsAndEventSlice';
import { isEmpty, join, map, size } from 'lodash';
import ReactPaginate from 'react-paginate';
import { WithContext as ReactTags } from "react-tag-input";
import { default as ReactSelect } from "react-select";
import { useSearchParams } from 'react-router-dom';
import no_data_found from "@/assets/images/svg/no_data_found.svg";
import ConsentManager from '../../components/ConsentManager';
import SeoHelmet from '@/components/SeoHelmet';
import seoConfig from '@/data/seo.config';
import PopUp from '@/modules/frontend/components/PopUp';
import BookADemo from '@/modules/frontend/components/BookADemo';

export default function Index() {

  const dispatch = useDispatch();
  const blogs = useSelector(state => state.galleryImages.blogs.data, shallowEqual);
  const blogsMetaData = useSelector(state => state.galleryImages.blogs.metadata, shallowEqual);
  const categories = useSelector(selectFormattedCategories2);

  const [searchParams, setSearchParams] = useSearchParams();
  let urlparameters = searchParams.get("c");
  const [limit, setLimit] = useState(9);
  const [offset, setOffset] = useState(0);

  const [selected_categories, setSelected_categories] = useState([]);
  const [smallmodalShow, setSmallModalShow] = useState(false);

  let pageCount = 0;

  if (blogsMetaData) {
    pageCount = Math.ceil(blogsMetaData.total / blogsMetaData.limit);
  }

  const CustomOption3 = ({ innerRef, innerProps, isSelected, label }) => {
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
        <input type="checkbox" checked={isSelected} readOnly />
        <label style={{ marginLeft: '8px' }}>{label}</label>
      </div>
    );
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      // backgroundColor: 'lightblue', // Background color of the control
      // borderColor: state.isFocused ? 'blue' : 'gray', // Border color when focused/unfocused
      '&:hover': {
        // borderColor: 'green', // Border color on hover
      },
    }),

    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#4c9bdb', // Background of the selected multi-value items
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff', // Color of the text inside the multi-value
      fontSize: "14px"
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      color: '#df0024', // Remove button color
      ':hover': {
        backgroundColor: '#df0024', // Background color on hover for the remove button
      },
    }),
    option: (base) => ({
      ...base,
      whiteSpace: "nowrap"
    })
  };

  const customFilter = (option, searchTxt) => {
    if (!isEmpty(option.data.code)) {
      if (option.data.text.toLowerCase().includes(searchTxt.toLowerCase())) {
        return true;
      }
    }
    if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  const handleCategoryChange = async (event) => {
    setSelected_categories(event);
    let category_names = map(event, 'text');
    category_names = join(category_names);

    let fObj = {
      offset: offset,
      limit: limit,
      column_name: "blog_publish_date",
      sort_dir: "DESC",
      search_term: category_names
    }

    await blogPosts(fObj);
  }

  const handlePageClick = async (event) => {
    let selctedIndex = event.selected + 1;
    let offsetVal = 0;
    if (selctedIndex === 1) {
      offsetVal = 0;
    } else {
      offsetVal = (selctedIndex - 1) * limit;
    }
    setOffset(offsetVal);
    let fObj = {
      offset: offsetVal,
      limit: limit,
      column_name: "blog_publish_date",
      sort_dir: "DESC",
      search_term: ""
    }
    await blogPosts(fObj);
    window.scrollTo(0, 0);
  }


  const blogPosts = async (filterObj) => {
    await dispatch(fetchBlogPosts(filterObj));
  }

  const fetchPosts = async (fObj) => {
    await blogPosts(fObj);
  }

  useEffect(() => {
    if (isEmpty(urlparameters)) {
      let fObj = {
        offset: offset,
        limit: limit,
        column_name: "blog_publish_date",
        sort_dir: "DESC",
        search_term: ""
      }
      fetchPosts(fObj);

    } else if (urlparameters && !isEmpty(categories)) {

      let catObj = categories.find((val) => val.id == urlparameters);
      handleCategoryChange([catObj]);
    }
  }, [urlparameters, categories]);

  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  return (
    <>
      <section className="inner-pad page">
        <SeoHelmet
          title={seoConfig.blogs.title}
          description={seoConfig.blogs.description}
          keywords={seoConfig.blogs.keywords}
          author={seoConfig.blogs.author}
        />

        <button
          className="btn outline small sticky-btn"
          onClick={handleQuoteClick}
          type="button"
        >
          Book A Demo
        </button>
        {/* inner banner wrape START  */}
        <div className="inner-banner blog-listing-wrape">
          <div className="container">
            <div className="content-wrape desk-hide">
              <h2>
                <span className="light">
                  Insights
                </span>&nbsp;
                <span className="blue">
                  &
                </span>&nbsp;
                <span className="black">
                  Updates
                </span>
              </h2>
              <p>Stay informed with industry trends, logistics knowledge and Orex updates.</p>
            </div>
          </div>
        </div>
        {/* inner banner wrape END  */}

        <div className="container map-bg">
          <div className=" inner-page-content-wrape">
            <div className="content-wrape mobile-show page-head ">
              <h2 className="mobile-head-text animate-child">
                <span className="light">
                  Insights
                </span> &nbsp;
                <span className="blue">
                  &
                </span> &nbsp;
                <span className="black">
                  Updates
                </span>
              </h2>
              <p className="animate-child">Stay informed with industry trends, logistics knowledge and Orex updates.</p>
            </div>

            <div className='head-filter'>
              <h1>Latest Blogs</h1>
              <div className='filter'>
                <div className='input-wrape select-wrape'>
                  <div className='input-pad select-wrape'>
                    <ReactSelect
                      options={categories}
                      isMulti
                      //onInputChange={handlePortsInputChange}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={true}
                      // className={`${props.isDisable || props.disableProfile ? `drop-down-disable-multi` : ` `}`}
                      className='select'
                      labelledBy="Search blogs by categories"
                      name="categories"
                      value={selected_categories}
                      classNamePrefix={"Drop-down-menu"}
                      onChange={handleCategoryChange}
                      components={{ Option: CustomOption3 }}
                      styles={customStyles}
                      noOptionsMessage={() => "No Categories Found"}
                      filterOption={customFilter}
                    //controlShouldRenderValue={false}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              {
                blogs && map(blogs, (b) => {
                  return (<div className='col-xxl-4' key={b.id}>
                    <BlogCard blog_detail={b} />
                  </div>)
                })
              }
            </div>

            <div className="bottom-control-wrape">
              <div className="pagination-wrape">
                {
                  pageCount > 1 && <ReactPaginate
                    //key={tableKey}
                    nextLabel=""
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel=""
                    pageClassName="number"
                    pageLinkClassName="number"
                    previousClassName="prev"
                    previousLinkClassName="prev"
                    nextClassName="next"
                    nextLinkClassName="next"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                }


                {/* <a href="javascript:void(0)" title="" className="prev"></a>
                <a href="javascript:void(0)" title="" className="number">1</a>
                <a href="javascript:void(0)" title="" className="number">2</a>
                <a href="javascript:void(0)" title="" className="number">3</a>
                <a href="javascript:void(0)" title="" className="number">4</a>
                <a href="javascript:void(0)" title="" className="number">..</a>
                <a href="javascript:void(0)" title="" className="next"></a> */}
              </div>
              <div className="page-count-wrape">
                {
                  blogsMetaData && blogsMetaData.total > 0 && `${(blogsMetaData.offset) + 1}-${(blogsMetaData.offset + blogsMetaData.count)} of ${blogsMetaData.total}`
                }
              </div>
              {blogsMetaData && blogsMetaData.total === 0 &&
                <div className="no-data"><img src={no_data_found} alt='No blog found.' /></div>
              }
            </div>
          </div>
        </div>
        <ConsentManager data={""} />
        {smallmodalShow && (
          <PopUp
            title="Book A Demo"
            smallmodalShow={smallmodalShow}
            setSmallModalShow={setSmallModalShow}
            className="book-demo"
          >
            <BookADemo
              setSmallModalShow={setSmallModalShow} />
          </PopUp>
        )}
         <ToastContainer />
      </section>
    </>
  )
}
